import { activityDetailConstants } from "../_constants";

export function activityDetail(
  state = { fetchingDetail: false, detail: {} },
  action
) {
  switch (action.type) {
    case activityDetailConstants.DETAIL_STATUS_REQUEST:
      return {
        ...state,
        fetchingDetail: true
      };
    case activityDetailConstants.DETAIL_STATUS_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail
      };
    case activityDetailConstants.DETAIL_STATUS_FAILURE:
      return {
        ...state,
        fetchingDetail: false
      };

    default:
      return state;
  }
}
